// import all components
import Navbar from "./navbar/navbar";
import Layout from "./layouts/index";
import Footer from "./footer/footer";

// import all modules


// import all data


// import css files
import "./App.css";


function App() {

  return (
    <>
      <Navbar />
      <Layout />
      <Footer />
    </>
  );

}

export default App;
